module.exports = __webpack_public_path__ + "media/images/job_list/icon_consulting-7fe0667076e74f0124ffaeabdc69e632.png";